import { AuthView } from '@daveyplate/better-auth-ui';
import { useLocation, useParams } from '@tanstack/react-router';

import { AnimatedNewsCards } from '@/components/AnimatedNewsCards';

export default function AuthPage() {
  const authFlow = useParams({
    from: '/auth/$authFlow',
    select: (params) => params.authFlow,
  });

  const { search } = useLocation();
  const error = new URLSearchParams(search).get('error');

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Left: Auth form - full width on mobile, 1/2 on lg+ */}
      <div className="flex w-full items-center justify-center bg-neutral-50 lg:w-1/2">
        <div className="mx-4 flex w-full max-w-md flex-col space-y-6 px-4">
          {/* Welcome text */}
          <div className="text-center">
            <h1 className="font-heading text-3xl font-semibold text-neutral-900">
              Bine ai venit
            </h1>
            <p className="mt-2 text-muted-foreground">
              Autentifică-te pentru a accesa contul tău
            </p>
          </div>

          {error && (
            <div className="rounded border-2 border-red-300 bg-red-100 px-4 py-2 text-sm text-red-700">
              {error}
            </div>
          )}

          <AuthView
            callbackURL={import.meta.env.DEV ? 'http://localhost:5173/' : '/'}
            pathname={authFlow}
            classNames={{
              base: 'auth-view px-2',
              content: 'gap-4',
              form: {
                icon: 'w-5 h-5 text-muted-foreground',
              },
            }}
          />
        </div>
      </div>

      {/* Right: Animated news cards - hidden on mobile, visible on lg+ */}
      <div className="hidden overflow-hidden lg:flex lg:w-1/2">
        <AnimatedNewsCards />
      </div>
    </div>
  );
}
